import React, { AnchorHTMLAttributes, FC, ReactNode } from 'react'
import ReactMarkdown from 'react-markdown'
import { Mention } from 'react-mentions'
import rehypeRaw from 'rehype-raw'

import { MENTION_PATTERN, USER_MENTION_PATTERN, UUID_PATTERN } from '../../utils'
import { Avatar, getAvantarColor, getAvatarInitials } from '../Avatar'
import * as S from './MentionUser.styles'
import { MentionUserProps, SugestionProps } from './MentionUser.types'

export const MentionUser: FC<MentionUserProps> = ({
  value,
  onChange,
  handleOnAdd,
  sugestions,
  readyOnly,
  placeholder,
}) => {
  // This is necessary to indetify mentions (@[userName](userId)) on ready only mode and replace the node style
  const parsedValue =
    readyOnly && value
      ? value.replace(/\n/gi, '<br>').replace(USER_MENTION_PATTERN, (text: string) => {
          return text.replace('@', '')
        })
      : ''

  const renderSuggestionOption = (
    suggestion: SugestionProps,
    _search: string,
    _highlightedDisplay: ReactNode,
    _index: number,
    focused: boolean,
  ) => {
    return (
      <S.SuggestionContainer key={suggestion.id} focused={focused}>
        <Avatar
          noBorder
          bgColor={getAvantarColor(suggestion.display)}
          initials={getAvatarInitials(suggestion.display)}
          widthValue="26px"
          heightValue="26px"
        />
        <S.Name>{suggestion.display}</S.Name>
      </S.SuggestionContainer>
    )
  }

  return !readyOnly && sugestions ? (
    <S.StyledMetionsInput
      value={value}
      onChange={onChange}
      style={S.mentionsInputStyles}
      placeholder={placeholder}
    >
      <Mention
        trigger={MENTION_PATTERN}
        data={sugestions}
        appendSpaceOnAdd
        onAdd={handleOnAdd}
        renderSuggestion={renderSuggestionOption}
        style={S.mentionStyles}
      />
    </S.StyledMetionsInput>
  ) : parsedValue ? (
    <S.CommentTextWrapper>
      <ReactMarkdown
        className="mention-user-readonly"
        children={parsedValue}
        rehypePlugins={[rehypeRaw]}
        components={{
          a: (props: AnchorHTMLAttributes<HTMLAnchorElement>) => {
            const { href, children } = props
            const isUser = href ? UUID_PATTERN.test(href) : false
            const hasHttp = href?.startsWith('http')
            return isUser ? (
              <S.StyledMentionText>{children}</S.StyledMentionText>
            ) : (
              <S.Link
                href={hasHttp ? href : `http://${href}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {children}
              </S.Link>
            )
          },
        }}
      />
    </S.CommentTextWrapper>
  ) : null
}
